<template>
  <div>
    <Dashboard />
    <section id="content">
      <div class="container">
        <ListHeaderTool
          @dateFilter="dateFilter"
          @filterType="filterType"
        ></ListHeaderTool>
      </div>
      <div class="container" id="content-item">
        <ListHeader />
        <FetchData
          :transactions="transactions"
          @openModal="openModal"
          @openBill="openBill"
        ></FetchData>
        <Loader :class="{ marinTop: mTop }" v-if="loader" />
        <Pagination
          :totalPage="totalPage"
          :selectTransactionType="selectTransactionType"
          :pageIndex="pageIndex"
          @fetchData="fetchData"
        ></Pagination>
      </div>
      <transition name="fade">
        <BillModal
          :show="showBill"
          :itemData="billData"
          :billMessage="billMessage"
          @hideBillModal="closeBillModal"
        ></BillModal>
      </transition>
      <transition name="fade">
        <Modal
          :show="showModal"
          :iscoin="iscoin"
          :itemData="modalData"
          @hideModal="closeModal"
          :headerData="headerData"
        ></Modal>
      </transition>
      <transition name="fade">
        <Error
          :errorMessage="errorMessage"
          v-if="errorModal"
          @hideErrorMessage="hideErrorMessage"
        ></Error>
      </transition>
    </section>
  </div>
</template>

<script>
import Modal from "@/components/transaction/ModalCoin";
import BillModal from "@/components/transaction/BillModal";
import Dashboard from "@/views/layout/Dashboard";
import Loader from "@/views/plugin/loader";
import Pagination from "@/views/plugin/pagination";
import Error from "@/views/plugin/error";
import FetchData from "./FetchData";
import ListHeaderTool from "./ListHeaderTool";
import ListHeader from "./ListHeader";
import EventBus from "@/EventBus.js";
import { Coin } from "@/mixins/Coin";
export default {
  mixins: [Coin],
  data() {
    return {
      transactions: {},
      modalData: [],
      billData: null,
      billMessage: "",
      headerData: {},
      pageIndex: "",
      errorMessage: "",
      totalPage: "",
      newStartDate: "",
      newEndDate: "",
      selectTransactionType: "",
      showModal: false,
      showBill: false,
      loader: true,
      errorModal: false,
      mTop: false,
      iscoin: false,
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    closeBillModal() {
      this.showBill = false;
    },
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    hideMenu() {
      EventBus.$emit("MOBILE_MENU_HIDE");
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    checkUser() {
      var tokenId = localStorage.getItem("authToken");
      if (tokenId == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            if (result.isEmployee === 0) {
              this.$router.push({ name: "transaction" });
            }
          } else if (result.status === 201) {
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch((error) => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
  },
  created() {
    this.fetchData();
    this.hideMenu();
    this.checkUser();
  },
  components: {
    Modal,
    Dashboard,
    Loader,
    Pagination,
    FetchData,
    Error,
    ListHeaderTool,
    ListHeader,
    BillModal,
  },
};
</script>

<style>
.marinTop {
  margin-top: 10%;
}
</style>
